import { FormattedMessage } from "react-intl";

import { Button } from "@ps-design-system/components/Button";
import { StatusPill } from "@ps-design-system/components/StatusPill";
import { Text } from "@ps-design-system/components/Text";
import ShowIcon from "@ps-design-system/icons/Show/Show16";
import StarFilledIcon from "@ps-design-system/icons/StarFilled/StarFilled16";

const VendorItem = ({ vendor }: { vendor: any }) => {
  const vendorStatus = "ACTIVATED" === vendor.status ? "Active" : "Pending";
  const hasReviews = vendor.review_count && vendor.review_stars;
  return (
    <div
      key={`vendor-${vendor._id}`}
      className="tw-border tw-border-gray-300 tw-rounded-4 tw-mb-40 last:tw-mb-56 tw-pb-24 tw-pt-20 tw-px-20 md:tw-p-24 md:tw-flex tw-justify-between tw-items-center tw-gap-10"
    >
      <img
        className="tw-aspect-[3/2] tw-object-cover tw-rounded-4 tw-w-full md:tw-max-w-[200px]"
        src={`https://res.cloudinary.com/peerspace-inc/image/upload/q_80,c_crop,g_custom/w_620,h_460,c_fill/${vendor?.cover_img?.external_id}`}
        alt={vendor.title}
      />
      <div className="flex-grow-1 tw-pt-12 md:tw-pt-0 md:tw-pl-24">
        <Text typeface="headline-3-b">{vendor.title}</Text>
        <div className="tw-flex tw-items-center tw-mb-4">
          {hasReviews && (
            <div className="tw-flex tw-gap-4 tw-items-center">
              <StarFilledIcon />
              <Text element="p" className="tw-mb-0">
                {vendor.review_stars} ({vendor.review_count})
              </Text>
            </div>
          )}
          {hasReviews && vendor.category_display_name && (
            <div className="tw-text-gray-600 tw-mx-8 tw--mt-2 tw-text-[8px]">
              •
            </div>
          )}
          {vendor.category_display_name && (
            <Text element="p" className="tw-mb-0">
              {vendor.category_display_name}
            </Text>
          )}
        </div>
        <Text element="p" className="tw-mb-0 tw-pb-12 tw-text-gray-600">
          {vendor.address}
        </Text>
        <StatusPill
          size="md"
          variant={vendorStatus === "Active" ? "green" : "yellow"}
        >
          {vendorStatus}
          <ShowIcon className="tw-ml-6" />
        </StatusPill>
      </div>
      <Button
        className="tw-w-full tw-mt-28 md:tw-mt-0 md:tw-w-fit"
        appearance="white"
        variant="outline-1"
        href={`/vendors/profile/${vendor._id}/edit`}
      >
        <FormattedMessage
          id="vendor.edit.edit_service"
          defaultMessage="Edit service"
        />
      </Button>
    </div>
  );
};

export default VendorItem;
